'use strict';

import * as TurboModuleRegistry from "../TurboModule/TurboModuleRegistry";
export default TurboModuleRegistry.get('NativeAnimatedModule');